import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  ActionBar,
  ActionBarItem,
  BaseEntity,
  Button,
  Column,
  confirm,
  createListErrorSelector,
  createListSelector,
  Equals,
  FilterObject,
  Form,
  FormField,
  Link,
  List,
  load,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  remove,
  translate
} from "clavis-nxt-components-custdevtm";
import { EnvironmentConfigurationEntity } from "../../domain/EnvironmentConfigurationEntity/EnvironmentConfigurationEntity";
import { LocalConfigurationEntity } from "../../domain/LocalConfigurationEntity/LocalConfigurationEntity";
import "./ConfigurationModal.scss";

class ConfigurationModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      entity: null
    };
  }

  componentDidMount() {
    this.props.type === "local"
      ? this.loadConfigurationLocal()
      : this.loadConfigurationEnvironment();
  }

  addNewHandler = () => {
    let entity =
      this.props.type === "local"
        ? new LocalConfigurationEntity()
        : new EnvironmentConfigurationEntity();

    entity.configuration = this.props.entity.id;

    this.setState({
      entity: entity
    });
  };

  cancelHandler = () => {
    this.setState({
      entity: null
    });
  };

  deleteEntity = entity => {
    this.props.remove(entity).promise.then(() => {
      this.setState(
        {
          entity: null
        },
        () => {
          this.props.type === "local"
            ? this.loadConfigurationLocal()
            : this.loadConfigurationEnvironment();
        }
      );
    });
  };

  insert = formProps => {
    formProps.insert(this.state.entity).promise.then(() => {
      this.setState(
        {
          entity: null
        },
        () => {
          this.props.type === "local"
            ? this.loadConfigurationLocal()
            : this.loadConfigurationEnvironment();
        }
      );
    });
  };

  loadConfigurationEnvironment = () => {
    let filterObject = new FilterObject(
      EnvironmentConfigurationEntity,
      "EnvironmentConfigurationEntityFilter"
    );

    filterObject.add(new Equals("configuration", this.props.entity.id));

    this.props.loadAll(filterObject);
  };

  loadConfigurationLocal = () => {
    let filterObject = new FilterObject(
      LocalConfigurationEntity,
      "LocalConfigurationEntityFilter"
    );

    filterObject.add(new Equals("configuration", this.props.entity.id));

    this.props.loadAll(filterObject);
  };

  modifyHandler = entity => {
    this.setState({
      entity: entity
    });
  };

  required = value => {
    const { t } = this.props;
    if (!value && value !== 0) {
      return [t("modal.configuration.required")];
    }
  };

  update = formProps => {
    formProps.update(this.state.entity).promise.then(() => {
      this.setState(
        {
          entity: null
        },
        () => {
          this.props.type === "local"
            ? this.loadConfigurationLocal()
            : this.loadConfigurationEnvironment();
        }
      );
    });
  };

  renderModify = props => {
    const { t } = this.props;
    return (
      <Link click={() => this.modifyHandler(props.entity)}>
        {t("modal.configuration.modify")}
      </Link>
    );
  };

  renderDelete = props => {
    const { t } = this.props;
    return (
      <Link
        className={"edit-label-color-warning"}
        click={() =>
          this.createConfirmAction(() => {
            this.deleteEntity(props.entity);
          }, t("components.ConfirmModal.Delete"))()
        }
      >
        {t("modal.configuration.delete")}
      </Link>
    );
  };

  renderEnvironmentForm = () => {
    const { t } = this.props;
    return (
      <Fragment>
        <FormField
          description={t("modal.configuration.required")}
          property={"environmentCode"}
          title={t(
            "entity.EnvironmentConfigurationEntity.property.environmentCode"
          )}
          validate={this.required}
        />
        <FormField
          description={t("modal.configuration.required")}
          property={"confValue"}
          title={t("entity.EnvironmentConfigurationEntity.property.confValue")}
          validate={this.required}
        />
      </Fragment>
    );
  };

  renderLocalForm = () => {
    const { t } = this.props;
    return (
      <Fragment>
        <FormField
          description={t("modal.configuration.required")}
          property={"confValue"}
          title={t("entity.LocalConfigurationEntity.property.confValue")}
          validate={this.required}
        />
      </Fragment>
    );
  };

  columnGenerator = () => {
    const { t } = this.props;
    const columnList = [
      ["id", "configuration", "confValue"],
      ["id", "configuration", "environmentCode", "confValue"]
    ];
    let columns = [];
    let key = this.props.type === "local" ? 0 : 1;
    let type =
      this.props.type === "local"
        ? "LocalConfigurationEntity"
        : "EnvironmentConfigurationEntity";

    for (let i = 0; i < columnList[key].length; i++) {
      columns.push(
        <Column
          propName={columnList[key][i]}
          sortable
          title={t("entity." + type + ".property." + columnList[key][i])}
        />
      );
    }

    columns.push(
      <Column>
        <this.renderModify />
      </Column>
    );

    columns.push(
      <Column>
        <this.renderDelete />
      </Column>
    );

    return columns;
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        centered
        className={"configuration-details-modal"}
        isOpen={this.props.isOpen}
        size={"lg"}
      >
        <ModalHeader toggle={() => this.props.toggle("isOpenConfiguration")}>
          {t(
            this.props.type === "local"
              ? "modal.configuration.title.local"
              : "modal.configuration.title.environment"
          )}
        </ModalHeader>
        <ModalBody>
          <div>
            {!this.state.entity && (
              <ActionBar>
                <ActionBarItem
                  icon={"icon-addnew interaction-color"}
                  labelColor={"interaction-color"}
                  labelRight={t("modal.configuration.addConfiguration")}
                  onClick={this.addNewHandler}
                />
              </ActionBar>
            )}
            {this.state.entity && (
              <Form
                entity={this.state.entity}
                onChange={entity => this.setState({ entity: entity })}
                render={formProps => (
                  <div className={"form-content"}>
                    {this.props.type === "local"
                      ? this.renderLocalForm()
                      : this.renderEnvironmentForm()}
                    <Link
                      click={() => {
                        formProps.setTouchedForm();
                        if (formProps.valid) {
                          this.state.entity.id
                            ? this.update(formProps)
                            : this.insert(formProps);
                        }
                      }}
                    >
                      {t(
                        !this.state.entity.id
                          ? "modal.configuration.link.insert"
                          : "modal.configuration.link.update"
                      )}
                    </Link>
                    <Link click={this.cancelHandler}>
                      {t("modal.configuration.link.cancel")}
                    </Link>
                  </div>
                )}
              />
            )}
          </div>
          <List
            compactView
            entities={
              this.props.type === "local"
                ? this.props.configurationLocalEntities
                : this.props.configurationEnvironmentEntities
            }
            id={"configuration-connected-list"}
            hasErrorFromServer={
              this.props.type === "local"
                ? this.props.configurationLocalError
                : this.props.configurationEnvironmentError
            }
            markHoveredRow
          >
            {this.columnGenerator()}
          </List>
        </ModalBody>
        <ModalFooter>
          <Button
            buttonType={"custom"}
            classes={"button-text-color secondary-inverted-background-color"}
            click={() => this.props.toggle("isOpenConfiguration")}
          >
            {t("modal.configuration.button.cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadAll: filterObject => dispatch(load(filterObject)),
  remove: entity => dispatch(remove(entity))
});

const mapStateToProps = (state, props) => {
  return {
    configurationEnvironmentEntities: createListSelector(
      EnvironmentConfigurationEntity,
      "EnvironmentConfigurationEntityFilter"
    )(state, props),
    configurationEnvironmentError: createListErrorSelector(
      EnvironmentConfigurationEntity,
      "EnvironmentConfigurationEntityFilter"
    )(state, props),
    configurationLocalEntities: createListSelector(
      LocalConfigurationEntity,
      "LocalConfigurationEntityFilter"
    )(state, props),
    configurationLocalError: createListErrorSelector(
      LocalConfigurationEntity,
      "LocalConfigurationEntityFilter"
    )(state, props)
  };
};

ConfigurationModalComponent.propTypes = {
  // Instance of ConfigurationEntity (only modify)
  entity: PropTypes.instanceOf(BaseEntity).isRequired,
  // Boolean to control the state of the modal
  isOpen: PropTypes.bool.isRequired,
  // Callback for toggling isOpen in the controlling component
  toggle: PropTypes.func.isRequired,
  // Type of configurations
  type: PropTypes.string
};

ConfigurationModalComponent.defaultProps = {
  isOpen: false,
  type: "local"
};

export const ConfigurationModal = translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(confirm(ConfigurationModalComponent))
);
